import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "discount-badge"
}
const _hoisted_2 = {
  key: 1,
  class: "countdown-row"
}
const _hoisted_3 = { class: "countdown-header" }
const _hoisted_4 = {
  key: 1,
  class: "item-info-line"
}
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = { class: "payment-methods" }
const _hoisted_8 = {
  key: 1,
  class: "viabill-section"
}
const _hoisted_9 = ["data-price", "data-currency"]

import addToCart from "./add-to-cart.vue";
import labels from "../../shared/labels";
import { computed, type PropType } from "vue";
import { type ShopProduct } from "./types";
import { createCurrencyFormatter } from "../common/amount-format";
import { format } from "../../../../shared/utils/string";
import { getCheapestFreightMethod } from "../product-specs/delivery-info";
import {
    type PaymentMethodKey,
    type PaymentLogoKey,
} from "../../checkout/payment-type/payment-method";
import { getPaymentMethodLogos } from "../../checkout/payment-type/image-urls";
import { isValidSecondsleft } from "../../../commons/product/auction/countdown";
import CountdownTime from "../auction/countdown-time.vue";
import PaymentCardItem from "./PaymentCardItem.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'specs',
  props: {
    product: {
        type: Object as PropType<ShopProduct>,
        required: true,
    },
    paymentKeys: Array as PropType<(PaymentLogoKey | PaymentMethodKey)[]>,
},
  setup(__props) {

const formatter = createCurrencyFormatter();

// eslint-disable-next-line no-undef
const props = __props;

const currency = window.odendo.globals.currency;

function formatAmounts(value: number) {
    return formatter.format(value);
}

const cheapestMethod = computed(() => {
    return getCheapestFreightMethod(
        props.product.freightMethods.filter((x) => x.isPickupMethod !== true)
    );
});

const cardPaymentLogos = computed(() => {
    if (props.paymentKeys == null || props.paymentKeys.length == 0) return [];
    return getPaymentMethodLogos(props.paymentKeys);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.$style['price-container'])
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.$style['buy-price'])
      }, [
        _createTextVNode(_toDisplayString(formatAmounts(__props.product.buyPrice)) + " ", 1 /* TEXT */),
        (__props.product.experienceDealsFee != null)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(_ctx.$style['buy-price-fee'])
            }, _toDisplayString(_unref(format)(
                            _unref(labels).frontendProductpage.specs
                                .experienceDealsFeeSubText,
                            formatAmounts(__props.product.experienceDealsFee)
                        )), 3 /* TEXT, CLASS */))
          : _createCommentVNode("v-if", true)
      ], 2 /* CLASS */),
      (
                    __props.product.showEstimatedPrice &&
                    __props.product.estimatedPrice > __props.product.buyPrice
                )
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(_ctx.$style['estimated-price'])
          }, _toDisplayString(_unref(labels).frontendProductpage.specs.shopEstimatedProductPrice) + " " + _toDisplayString(formatAmounts(__props.product.estimatedPrice)), 3 /* TEXT, CLASS */))
        : _createCommentVNode("v-if", true)
    ], 2 /* CLASS */),
    (
                __props.product.showEstimatedPrice &&
                __props.product.estimatedPrice != null &&
                __props.product.buyPrice != null &&
                __props.product.estimatedPrice > __props.product.buyPrice &&
                Math.round(
                    (1 - __props.product.buyPrice / __props.product.estimatedPrice) * 100
                ) >= 10
            )
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_unref(format)(
                    _unref(labels).frontendProductList.discount,
                    Math.round(
                        (1 - __props.product.buyPrice / __props.product.estimatedPrice) * 100
                    ) + "%"
                )), 1 /* TEXT */))
      : _createCommentVNode("v-if", true),
    (_unref(isValidSecondsleft)(__props.product.timeTotalSeconds))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(__props.product.timeIsNotStarted
                        ? _unref(labels).frontendProductList.productSpecs.headers
                              .timeLeftToStart_shop
                        : _unref(labels).frontendProductList.productSpecs.headers
                              .timeLeft_shop), 1 /* TEXT */),
          _createVNode(CountdownTime, {
            class: "countdown-time",
            "seconds-left": __props.product.timeTotalSeconds
          }, {
            header: _withCtx(() => _cache[0] || (_cache[0] = [])),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["seconds-left"])
        ]))
      : _createCommentVNode("v-if", true),
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.$style['buy-section'])
    }, [
      (__props.product.stock != null)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass([_ctx.$style['stock-status'], 'item-info-line'])
          }, [
            _createElementVNode("i", {
              class: _normalizeClass(
                        _ctx.$style['icon-stock-status'] +
                        ' icon-stock-status--' +
                        __props.product.stock.status
                    )
            }, null, 2 /* CLASS */),
            _createTextVNode(" " + _toDisplayString(__props.product.stock.text), 1 /* TEXT */)
          ], 2 /* CLASS */))
        : _createCommentVNode("v-if", true),
      (cheapestMethod.value != null)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("strong", null, _toDisplayString(_unref(labels).frontendProductpage.shop.freightPriceLabel) + ":", 1 /* TEXT */),
            _createTextVNode(" " + _toDisplayString(formatAmounts(cheapestMethod.value.price)), 1 /* TEXT */)
          ]))
        : _createCommentVNode("v-if", true),
      (
                    __props.product.stock != null &&
                    __props.product.stock.count > 0 &&
                    __props.product.freightMethods.some((x) => x.isPickupMethod != true)
                )
        ? (_openBlock(), _createElementBlock("div", {
            key: 2,
            innerHTML: _unref(labels).frontendProductpage.shop.infoItems_delivery,
            class: "item-info-line"
          }, null, 8 /* PROPS */, _hoisted_5))
        : _createCommentVNode("v-if", true),
      (
                    __props.product.stock != null &&
                    __props.product.stock.count > 0 &&
                    __props.product.freightMethods.some((x) => x.isPickupMethod != true)
                )
        ? (_openBlock(), _createElementBlock("div", {
            key: 3,
            innerHTML: _unref(labels).frontendProductpage.shop.infoItems_return,
            class: "item-info-line"
          }, null, 8 /* PROPS */, _hoisted_6))
        : _createCommentVNode("v-if", true),
      _createVNode(addToCart, {
        "product-id": __props.product.id,
        stock: __props.product.stock,
        action: __props.product.addToCartAction,
        class: "add-to-cart-comp"
      }, null, 8 /* PROPS */, ["product-id", "stock", "action"]),
      _createElementVNode("div", _hoisted_7, [
        (cardPaymentLogos.value != null)
          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(cardPaymentLogos.value, (cardPaymentLogo) => {
              return (_openBlock(), _createBlock(PaymentCardItem, { "card-payment-logo": cardPaymentLogo }, null, 8 /* PROPS */, ["card-payment-logo"]))
            }), 256 /* UNKEYED_FRAGMENT */))
          : _createCommentVNode("v-if", true),
        (__props.paymentKeys?.includes('PayEx') == true)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createElementVNode("div", {
                class: "viabill-pricetag",
                "data-view": "product",
                "data-price": __props.product.buyPrice,
                "data-currency": _unref(currency)
              }, null, 8 /* PROPS */, _hoisted_9)
            ]))
          : _createCommentVNode("v-if", true)
      ])
    ], 2 /* CLASS */)
  ]))
}
}

})